import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsViolentRightsSuppressionGroupItemValidator from './validators/item';
import { LegalAssociationsViolentRightsSuppressionGroupModel } from './types';

const legalAssociationsViolentRightsSuppressionGroupValidator: ValidateJSModel<LegalAssociationsViolentRightsSuppressionGroupModel> = {
  HasViolentRightsSuppressionGroup: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasViolentRightsSuppressionGroup?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsViolentRightsSuppressionGroupItemValidator },
      };
    }
    return {};
  },
};

export default legalAssociationsViolentRightsSuppressionGroupValidator;
